module.exports = __webpack_public_path__ + "img/QuickEntrance_yqkk.53a3e53b.svg";